import { types } from './types';

const INITIAL_STATE = {
  variables: {},
  permissions: {},
};

const reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.UPDATE_FORM_FIELD:
      return {
        ...state,
        [payload.group]: {
          ...state[payload.group],
          [payload.key]: payload.value,
        },
      };
    case types.GET_FUNDING_ADMIN_APPTRACK.SUCCESS:
      return {
        ...state,
        variables: payload.variables,
        resultSize: payload.resultSize,
        activeTaskName: payload.activeTaskName,
        applStatus: payload.variables.applStatus,
        loadingApptrack: false,
        interestApplication: {},
      };
    case types.GET_FUNDING_ADMIN_APPTRACK.START:
      return {
        ...state,
        loadingApptrack: true,
      };
    case types.GET_FUNDING_ADMIN_APPTRACK.ERROR:
      return {
        ...state,
        loadingApptrack: false,
      };
    case types.GET_FUNDING_ADMIN_APPTRACK.START:
      return {
        ...state,
        loadingApptrack: true,
      };
    case types.GET_INTEREST_APPLICATION.START:
      return {
        ...state,
        loadingApptrack: true,
      };
    case types.GET_INTEREST_APPLICATION.SUCCESS:
      return {
        ...state,
        interestApplication: payload,
      };
    case types.REVIEW_INTEREST_APPLICATION.ERROR:
        return {
        ...state,
        error: { ...payload },
        loading: false,
      };
    case types.FETCH_PROCESS_SAYT.SUCCESS:
      return {
        ...state,
        sayt: payload,
      };
    case types.CLEAR_SAYT:
      return {
        ...state,
        sayt: {},
      };
    case types.GET_ACTIONS.SUCCESS:
      return {
        ...state,
        permissions: {
          ...state.permissions,
          ...payload,
        },
      };
    case types.CLEAR_APPTRACK.SUCCESS:
      return INITIAL_STATE;
    case types.GET_APPTRACK_DETAILS.SUCCESS:
      return {
        ...state,
        apptrackDetails: payload,
        loading: false,
      };
    case types.SET_APPTRACK_LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.GET_ALL_TASK_NAMES.SUCCESS:
      return {
        ...state,
        taskNames: payload.map(name => ({ name })),
      };
    default:
      return state;
  }
};

export default reducer;
